import { ReactNode } from 'react';
import { IconChevronDown } from '@tabler/icons-react';
import { Text } from '@mantine/core';
import classes from './NavbarLink.module.css';

interface NavbarLinkProps {
  label: string;
  link: string;
  id?: string;
  active?: boolean;
  onClick( event?: React.MouseEvent ): void;
  icon?: ReactNode;
  hasDropdown?: boolean;
  subtitle?: string;
  /**
   * Trailing content pinned to the right edge of the row — a status Badge, a
   * count, etc. Added by TV1-2294 ticket 28 (GAP 3) so the mobile drawer's
   * tutorial rows can carry the SAME per-tour status badge the desktop
   * AccountMenu renders via `Menu.Item`'s `rightSection`; the drawer showed
   * label + subtitle only, so a tutorial's status was invisible on mobile.
   */
  rightSection?: ReactNode;
}

function NavbarLink({ label, id, link, active, onClick, icon, hasDropdown, subtitle, rightSection }: NavbarLinkProps ) {
  return (
    <div
      key={label}
      id={id}
      className={active ? classes.linkActive : classes.link}
      onClick={( event ) => {
        event.preventDefault();
        onClick( event );
      }}
    >
      <div className={classes.content}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
          {icon && <span className={classes.icon}>{icon}</span>}
          <span>{label}</span>
          {hasDropdown && (
            <IconChevronDown
              className={classes.chevron}
              size={14}
              stroke={2}
            />
          )}
        </div>
        {subtitle && (
          <Text
            c="dimmed"
            style={{
              whiteSpace: 'normal',
              wordWrap: 'break-word',
              lineHeight: '1.2',
              fontSize: '11px',
              marginTop: '3px'
            }}
          >
            {subtitle}
          </Text>
        )}
      </div>
      {rightSection && (
        <span className={classes.rightSection}>{rightSection}</span>
      )}
    </div>
  );
}

export default NavbarLink;
